import * as angular from 'angular';
import { CohortComponent } from './cohort.component';
import { MetricsSelectionRowModule } from './rows/metrics-select-row/metrics-selection-row.module';
import { MetricsTextInputRowModule } from './rows/metrics-text-input-row/metrics-text-input-row.module';

export const CohortModule = angular
  .module('cohort', [MetricsSelectionRowModule, MetricsTextInputRowModule])
  .component('cohortComponent', CohortComponent).name;
